import { render, staticRenderFns } from "./checkout-payment.vue?vue&type=template&id=f9cd8060&scoped=true"
import script from "./checkout-payment.vue?vue&type=script&lang=js"
export * from "./checkout-payment.vue?vue&type=script&lang=js"
import style0 from "./checkout-payment.vue?vue&type=style&index=0&id=f9cd8060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9cd8060",
  null
  
)

export default component.exports